import React from "react";
import Typography from "@material-ui/core/Typography";
import MaterialTable from "material-table";
import tableicons from "../tableicons";
import {ValidacionConteoResources} from "../endpoints";
import SearchIcon from "@material-ui/icons/Search";

class CantidadesXRevisar extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            datos:[],
            cargando:true,
            openSnack:false,
            severity: null,
            message:null,
        }
    }

    verDetalles = (rowData) =>{
        this.props.history.push("/detalles_tag/" + rowData.tag)
    }


    handleChangeLoading = () =>{
        //NO BORRAR
    }

    consultarTag = () =>{
        ValidacionConteoResources.getCantidadesRevisar().then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(data => {
            if (data.status_code === 200) {
                this.setState({datos: data.consulta, cargando: false})
            } else if (data.status_code === 401) {
                this.setState({openSnack: true, severity: data.severity, message: data.message})
            } else {
                throw new Error('Something went wrong ...');
            }
        }).catch(error => {
            console.error(error);
        });
    }

    componentDidMount() {
        this.consultarTag()
    }

    render() {
        return(
            <div>
                <Typography variant="h4" gutterBottom>
                    Cantidades x Revisar
                </Typography>
                <MaterialTable
                    localization={{
                        toolbar: {
                            searchPlaceholder: 'Buscar',
                        },
                        header: {
                            actions: 'Acciones'
                        },
                        body:{
                            emptyDataSourceMessage: 'No hay datos para mostrar'
                        },
                    }}
                    icons={tableicons}
                    title=""
                    data={this.state.datos}
                    isLoading={this.state.cargando}
                    columns={[
                        { title: 'Tag', field: 'tag'},
                        { title: 'Id fleje', field: 'lote'},
                        { title: 'Código', field: 'codigo'},
                        { title: 'Cantidad', field: 'cantidad'},
                    ]}
                    options={{
                        defaultExpanded: true,
                        pageSize: 50,
                        pageSizeOptions: [10, 25, 50, 100],
                        actionsColumnIndex: -1,
                        rowStyle: rowData => ({
                            backgroundColor: (this.state.selectedRow === rowData.tableData.id) ? '#dbe9fc' :  (rowData.avance === 1 && rowData.descripcion !=='SIN UBICACION') ? '#6fbf73' : (rowData.cant_inv === 0) ? '#FD8080' :  (rowData.descripcion === 'SIN UBICACION') ? '#EC7063':'#FFF'
                        }),
                        searchFieldStyle: {
                            width: "auto",
                        },
                        padding: "dense"
                    }}
                    components={{

                    }}
                    actions={[
                        {
                            icon:  () => <SearchIcon style={{fontSize:27, margin:4}}/>,
                            tooltip: 'Ver detalle',
                            onClick: (event, rowData) => this.verDetalles(rowData),
                        },
                    ]}
                    onRowClick={(event, rowData) => this.setState({selectedRow: rowData.tableData.id})}
                />
            </div>
        )
    }

}

export default CantidadesXRevisar;